import * as React from 'react';
import { useSelector } from 'react-redux';

import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';

import { trackCategoriesShow, trackCategoryClick } from './tracking';
import { Categories } from '../../components/Categories';
import { selectCategories } from '../../selectors/promosPage';

export const CategoriesContainer = () => {
  const categories = useSelector(selectCategories);

  if (!categories.length) {
    return null;
  }

  return (
    <ActionAfterViewObserver callback={trackCategoriesShow}>
      <Categories categories={categories} onCategoryClick={trackCategoryClick} />
    </ActionAfterViewObserver>
  );
};
